import { SkeletonArea } from 'components/skeletonArea';

export const SkeletonIppicaQuoteFinaliArea = () => {
  return (
    <>
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
      <SkeletonArea height={'8'} />
    </>
  );
};
